<template>
    <div>
        <b-table
            bordered
            :fields="fields"
            :items="data.data"
            :small="true"
            thead-class="thead-orange"
        >
        <template slot="mail_type" slot-scope="data">
           <i class="fa" :class="data.item.mail_type.fa_class"></i> {{ data.item.mail_type.name }} 
        </template>
        <template slot="created_at" slot-scope="data">
            {{data.item.created_at | datetime}}
        </template>
        <template slot="duration" slot-scope="data">
            {{data.item.created_at | duration}}
        </template>
        </b-table>
        <app-paginator 
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        />
    </div>
</template>

<script>
import fields from './fields';
import Paginator from '../../../../UI/Controls/Paginator/Paginator.vue';
export default {
    components: {
        appPaginator: Paginator
    },

    props: {
        data: {
            required: true
        },
        onChangePage: {
            type: Function,
            required: true
        }
    },

    data(){
        return{
            fields: fields
        }
    }
}
</script>